import request from '@/utils/request';
import { loginOrg, loginUser, loginCompany } from '@/utils/LoginContext';
import { stringify } from 'qs';
export async function save(payload) {
  return request(`/iwms-wms/wms/articleBusiness`, {
    method: 'POST',
    body: payload,
  });
}

export async function modify(payload) {
  return request(`/iwms-wms/wms/articleBusiness/modify`, {
    method: 'POST',
    body: payload,
  });
}

export async function getByDcUuidAndArticleUuid(payload) {
  return request(`/iwms-wms/wms/articleBusiness/getByDcUuidAndArticleUuid?dcUuid=${loginOrg().type === 'DC' ? loginOrg().uuid : payload.dcUuid}&articleUuid=${payload.articleUuid}`);
}

export async function getByDcUuidAndArticleUuidForWeb(payload) {
  return request(`/iwms-wms/wms/articleBusiness/getByDcUuidAndArticleUuidForWeb?dcUuid=${loginOrg().type === 'DC' ? loginOrg().uuid : payload.dcUuid}&articleUuid=${payload.articleUuid}`);
}

export async function queryByArticles(payload) {
  return request(`/iwms-wms/wms/articleBusiness/query/articles?dcUuid=${loginOrg().type === 'DC' ? loginOrg().uuid : payload.dcUuid}`, {
    method: 'POST',
    body: payload.articleUuids,
  });
}

// 商品业务信息批量导入
export async function articleBusinessBatchImport(payload) {
  return request(`/iwms-wms/wms/articleBusiness/batchImport?companyUuid=${loginCompany().uuid}&dcUuid=${loginOrg().uuid}&fileKey=${payload.fileKey}`, {
    method: 'POST'
  });
}

export async function querySettleQpcStr(payload) {
  return request(`/iwms-wms/wms/articleBusiness/querysettleqpcstr?${stringify(payload)}`);
}
